import React from 'react';
import useBackendApi from '../../hooks/useBackendApi';
import { IReview } from '../../types/review';
import { IReviewDimension } from '../../types/reviewFormData';

function reducer(state, { type, payload }) {
  switch (type) {
    case 'SET_STATE':
      return payload;
    case 'UPDATE_REVIEWS':
      return {
        ...state,
        reviewItems: [...state.reviewItems, ...payload.reviewItems],
        pagination: payload.pagination,
      };
    default:
      return state;
  }
}

export default function useReviewsContainerData({
  apiUrl = '/v1/reviews/all',
  limit = 20,
  hideLoader = false,
}) {
  const { get } = useBackendApi();
  const [state, dispatch]: [
    {
      summary: IReviewDimension[];
      totalCount: number;
      averageScore: number;
      reviewItems?: IReview[];
      pagination: {
        page: number;
        limit: number;
      };
    },
    any
  ] = React.useReducer(reducer, {
    summary: [],
    totalCount: 0,
    averageScore: 0,
    reviewItems: [],
    pagination: {
      page: 1,
      limit,
    },
  });

  React.useEffect(() => {
    if (apiUrl) {
      const fetch = async () => {
        const res = await get(apiUrl, state.pagination, {
          loader: !hideLoader,
        });
        const reviewData = res.data.doc?.review;
        const summary = reviewData?.dimensions || [];
        const totalCount = reviewData?.totalCount || 0;
        const averageScore = reviewData?.averageScore || 0;
        const reviewItems = res.data.docs || [];
        const pagination = res.data.apiFeatures;
        const payload = {
          summary,
          totalCount,
          averageScore,
          reviewItems,
          pagination,
        };
        dispatch({ type: 'SET_STATE', payload });
      };
      fetch();
    }
  }, [apiUrl]);

  async function handleFetchNextSetOfReviews() {
    const itemsLength = state.reviewItems?.length || 0;
    const page = Math.floor(itemsLength / limit) + 1;
    const newPagination = { ...state.pagination, page };
    const res = await get(apiUrl, newPagination);
    const reviewItems = res.data.docs || [];
    dispatch({
      type: 'UPDATE_REVIEWS',
      payload: { reviewItems, pagination: newPagination },
    });
  }

  return {
    ...state,
    handleFetchNextSetOfReviews,
  };
}
